import { render, staticRenderFns } from "./academicConferencesDeatils.vue?vue&type=template&id=ccf93de0&scoped=true&"
import script from "./academicConferencesDeatils.vue?vue&type=script&lang=js&"
export * from "./academicConferencesDeatils.vue?vue&type=script&lang=js&"
import style0 from "./academicConferencesDeatils.vue?vue&type=style&index=0&id=ccf93de0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf93de0",
  null
  
)

export default component.exports